import { put, call, all, takeLatest, select } from "redux-saga/effects";
import {
  REQRegisDeviceList,
  RESRegisDeviceList,
  FailRegisDeviceList
} from "./actions";
import * as actions from "../../Authentication/redux/actions";



function* fetchRegisDeviceListWorker({ payload }) {
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { page, tSrch } = payload;


    const request = yield fetch(
      `${process.env.REACT_APP_API_ADMIN_URL}/api/v1/admin-actions/registerDeviceList?page=${page}&search=${tSrch}`,
      {
        method: "GET",  
        headers: {
          "Content-Type": "application/json",
          userid: tGUID,
          'x-id-token': "Bearer " + accessToken
        }
      }
    );
    if (request.status === 401) {
      yield put(actions.autoSignOut()); 
      return; 
    }
    const response = yield request.json();

    if (response && response.data && response.total) {
      yield put(RESRegisDeviceList(response));
    } else {
            yield put(FailRegisDeviceList());
    }
  } catch (error) {
    
    yield put(FailRegisDeviceList());
  }
}

export function* regisDeviceListSaga() {
  yield all([takeLatest(REQRegisDeviceList, fetchRegisDeviceListWorker)]);
}
